<template>
  <section>
    <offer-list :query="query" />
  </section>
</template>

<script>
import OfferList from '@/components/company/OfferList'

export default {
  name: 'Offers',
  components: {
    OfferList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
